/// \file securityRoles.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const SecurityRolesList = lazy(() => import('../views/security-roles/list/view'));

async function securityRolesDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/security-roles/list/loader')).default;
  return actualLoader(args);
}

export async function securityRolesAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/security-roles/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="securityRoles"
    handle={{
      text: 'Security Roles'
      }}
  >
    <Route 
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <SecurityRolesList />
        </Suspense>
      }     
      loader={securityRolesDataLoader}
      action={securityRolesAction}
      />
  </Route>
);

export default routes;